module.exports = __webpack_public_path__ + "static/media/gamechasers.6ccf8216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/avatars/gamechasers.jpg
// module id = 37
// module chunks = 0